import Scrollbar from 'smooth-scrollbar';
export default () =>{
    

    const casitaPopups = document.querySelectorAll('.popup-casitas');
    casitaPopups?popupHandle():false;

    function popupHandle(){
        casitaPopups.forEach(casitaPopup => {
            const buttons = casitaPopup.querySelectorAll('.controls button');
            const images = casitaPopup.querySelectorAll('img')
        
            buttons.forEach(button =>{
                button.addEventListener('click', ()=>{
                    buttons.forEach(b =>{
                        b.classList.toggle('active')
                    })
                    images.forEach(img =>{
                        img.classList.toggle('hidden')
                    })
                })
            })
        })   
    }

    const fixed = document.querySelector('.fixed-box');
    fixed?fixedHandle():false;

    function fixedHandle(){
        fixed.style.top = window.innerHeight - fixed.offsetHeight + 'px';
        let scrollbar = Scrollbar.get(document.querySelector('.scroll-container'));
		scrollbar.addListener((status) => {
            
			fixed.style.top = status.offset.y + window.innerHeight - fixed.offsetHeight + 'px';
		});
    }
    
}